import { render, staticRenderFns } from "./CompanyTaxesConfig.vue?vue&type=template&id=bdf35c8e&scoped=true&"
import script from "./CompanyTaxesConfig.vue?vue&type=script&lang=js&"
export * from "./CompanyTaxesConfig.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTaxesConfig.vue?vue&type=style&index=0&id=bdf35c8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf35c8e",
  null
  
)

export default component.exports